
































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Platform} from 'quasar';
import ApplePayButton from '@/components/pay/ApplePayButton.vue';
import GooglePayButton from '@/components/pay/GooglePayButton.vue';
import {Browser} from '@cap/@capacitor/browser';
import {SessionStore, DeepLinkStore} from '@customer-portal/shared';
// @ is an alias to /src

@Component({
	components: {
		ApplePayButton,
		GooglePayButton
	}
})
export default class PayButton extends Vue {
	@Prop({required: true})
	locationId!: string;

	@Prop({required: true})
	total!: number;

	@Prop({required: true})
	label!: string;

	@Prop({default: false})
	isDisabled!: boolean;

	@Prop({default: ''})
	disabledMessage!: string;

	paymentType: 'apple-pay' | 'google-pay' | null = null;

	dummyDetails = {
		total: {
			label: 'Total',
			amount: {
				currency: 'USD',
				value: '0.00',
			},
		},
	};

	@Watch('tokenizeResult')
	onTempPayloadChange() {
		if(this.tokenizeResult) {
			console.log('tokenizeResult', this.tokenizeResult);
			Browser.close();

			// Clear this right away, we only want to use it once
			const payload = this.tokenizeResult;
			DeepLinkStore.clearTokenizeResult();
			this.$emit('payload', payload);
		}
	}

	get tokenizeResult() {
		return DeepLinkStore.tokenizeResult;
	}

	get brandConfig() {
		return SessionStore.brandConfig;
	}

	get authConfig() {
		return SessionStore.authConfig;
	}


	async openInAppBrowser(url: string) {
		try {
			await Browser.open({
				url: url,
				presentationStyle: 'fullscreen'
			});
		} catch(error) {
			this.$q.dialog({
				title: 'Error',
				message: 'There was a problem loading the reload page. Please try again.',
			});
			console.error(error);
		}
	}

	openMobilePay() {
		if(this.brandConfig) {
			const baseURL = new URL(this.brandConfig.customerPortalUrl);
			const searchParams = new URLSearchParams();
			searchParams.set('auth', btoa(JSON.stringify(this.authConfig)));
			searchParams.set('locationId', this.locationId);
			searchParams.set('total', this.total.toString());
			searchParams.set('label', this.label);
			// When you are developing locally you will need to set up some kind of
			// reverse proxy (such as using Cloudflare tunnels) to provide a https
			// endpoint that proxies back to your local dev server. Once you have that
			// in place you will need to update the customerPortalUrl in the WA
			// to point to your endpoint. This code below checks if you are using
			// hash routing and if so it will add the hash to the url so that your
			// dev server will correctly route the request.
			// This is ONLY used if we are in development mode and the url has a hash
			// already.

			// Here you can override this behavior if you want to use the hosted version
			const useHostedVersion = true;
			let addedHash = '';
			if(!useHostedVersion && (process.env.NODE_ENV === 'development' && location.hash !== '')) {
				addedHash = '#/';
			}
			const url = `${baseURL.origin}/${addedHash}mobile/tokenize?${searchParams.toString()}`;
			console.log('Opening mobile pay url', url);
			this.openInAppBrowser(url);
		}
	}

	async created() {
		// For some reason, that is 100% beyond me, this PaymentRequest creation throws
		// a "Line: 2, column: 1, Unexpected token." error in the console. It doesn't break
		// anything and is only thrown on Chrome. We are avoiding it by only checking if on
		// Safari
		const supportsApplePay = Platform.is.safari ? await new PaymentRequest(
			[{supportedMethods: 'https://apple.com/apple-pay'}],
			this.dummyDetails
		).canMakePayment() : false;

		const supportsGooglePay = await new PaymentRequest(
			[{supportedMethods: 'https://google.com/pay'}],
			this.dummyDetails
		).canMakePayment();

		if(supportsApplePay) {
			this.paymentType = 'apple-pay';
		} else if(supportsGooglePay) {
			this.paymentType = 'google-pay';
		}
	}
}
